'use client'

import { usePostHog } from '@posthog/next'
import { useEffect } from 'react'

export function PostHogObservability() {
  const posthog = usePostHog()

  useEffect(() => {
    window.dataLayer = window.dataLayer || []

    if (posthog.__loaded) {
      window.dataLayer?.push({
        event: 'posthog_loaded',
        posthog_user_distinct_id: posthog.get_distinct_id() || 'fail to get distinct id',
      })
    }
  }, [posthog])

  return null
}
